import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { BLACK, WATERLOO } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const CardContainer = styled.div`
  position: relative;

  &:hover {
    &.insight-card,
    .insight-card {
      &__image {
        img {
          box-shadow: 0 20px 60px ${rgba(BLACK, 0.3)};
        }
      }

      &__title {
        color: ${p => p.theme.palette.primary.main};
      }
    }
  }

  a {
    display: block;
    width: 100%;
    color: inherit;
    text-decoration: none;
  }

  &.insight-card,
  .insight-card {
    &__image {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      margin-bottom: 25px;

      img {
        max-width: 100%;
        max-height: 180px;
        border-radius: 6px;
        transition: all 0.4s;
        box-shadow: 0 14px 30px ${rgba(BLACK, 0.14)};
        overflow: hidden;

        ${breakpoints.up('xs')} {
          width: 100%;
          max-height: 100%;
        }
      }
    }

    &__labels {
      max-height: 30px;
      overflow: hidden;
      margin-bottom: 10px;

      .MuiChip-root {
        margin-bottom: 2px;

        &:not(:last-of-type) {
          margin-right: 5px;
        }
      }

      .labels-wrapper {
        overflow: hidden;
        max-height: 30px;

        span.dots {
          display: inline-block;
          margin-left: 5px;
          font-size: 25px;
          line-height: 1;
        }
      }
    }

    &__title {
      font-weight: 600;
      line-height: 2.8rem;
      transition: all 0.4s;
      margin-bottom: 20px;
    }

    &__info {
      display: flex;
      align-items: center;
    }

    &__author,
    &__data {
      font-weight: 600;
      font-size: 1.2rem;
      line-height: 1.2rem;
    }

    &__author {
      overflow: hidden;
    }

    &__data {
      color: ${WATERLOO};
      flex-shrink: 0;
    }
  }
`;

export default CardContainer;
